import { client } from './client'
import { createResponse } from '../response'

const fetchAppStoreReviews = async () => {
  try {
    let response = await client.get('/v1/apps/1/platform')
    return createResponse(response.data.apps)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchPlayStoreReviews = async () => {
  try {
    let response = await client.get('/v1/apps/2/platform')
    return createResponse(response.data.apps)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchOriginationCountries = async () => {
  try {
    let response = await client.get('/v1/originationcountries')
    return createResponse(response.data.originationCountries)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchCountries = async () => {
  try {
    let response = await client.get('/v1/countries')
    return createResponse(response.data.countries)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const updateAppReviews = async () => {
  try {
    await client.post('/v1/apps/update')
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const searchCallingCorridors = async (payload) => {
  try {
    let response = await client.get('/v1/callingcorridors/search/' + payload.origination + '/' + payload.destination)
    return createResponse(response.data.callingCorridors)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

const fetchPriceLeaderCountries = async (origination) => {
  try {
    let response = await client.get('/v1/callingcorridors/priceleader/' + origination)
    return createResponse(response.data.callingCorridors)
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

export {
  fetchAppStoreReviews,
  fetchPlayStoreReviews,
  updateAppReviews,
  fetchOriginationCountries,
  fetchCountries,
  searchCallingCorridors,
  fetchPriceLeaderCountries
}



// WEBPACK FOOTER //
// ./src/api/competitor/index.js